import { render, staticRenderFns } from "./loaderOverlay.vue?vue&type=template&id=810c0efa"
import script from "./loaderOverlay.vue?vue&type=script&lang=js"
export * from "./loaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./loaderOverlay.vue?vue&type=style&index=0&id=810c0efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports